import { useState, useEffect, useRef } from 'react';
import close from '../../assets/icons/close.svg';
import next from '../../assets/icons/icon.svg';
import useAutoFocus from '../../Utils/autoFocus';
import '../../assets/css/Modal.css';
import '../../assets/css/StudentDashboard.css'
import { getData, Postdata } from '../../API/GlobalApi';
export const AdmissionCancelModal = ({
    isOpen,
    onClose,
    cancelStudentId,
    fetchStudents, currentPage
}) => {


    const [cancelData, setCancelData] = useState(null)
    const [reason, setReason] = useState('');
    const [step, setStep] = useState(1); // 1 = Reason, 2 = OTP
    const [error, setError] = useState('');
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const otpRefs = useRef([]);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const [secondsLeft, setSecondsLeft] = useState(60);
    const [resendEnabled, setResendEnabled] = useState(false);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (step === 2) {
            setSecondsLeft(60);
            setResendEnabled(false);
            const countdown = setInterval(() => {
                setSecondsLeft((prev) => {
                    if (prev <= 1) {
                        clearInterval(countdown);
                        setResendEnabled(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(countdown);
        }
    }, [step]);



    const handleResendOtp = async () => {
        const url = `students/admission-cancellation/?student_id=${cancelStudentId}`;
        try {
            await getData(url);
            displayToast("OTP resent successfully");
            setOtp(new Array(6).fill(''));
            setSecondsLeft(60);
            setResendEnabled(false);
        } catch (err) {
            displayToast("Failed to resend OTP", "danger");
        }
    };



    const nameInputRef = useAutoFocus(isOpen);

    useEffect(() => {
        if (!isOpen) {
            setStep(1);
            setReason('');
            setOtp(new Array(6).fill(''));
            setError('');
        }
    }, [isOpen]);

    const displayToast = (message, variant = 'success') => {
        setToastMessage(message);
        setToastVariant(variant);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
    };


    const handleReasonConfirm = async () => {
        if (!reason.trim()) {
            setError('Cancel reason is required.');
            return;
        }

        if (reason.trim().length > 30) {
            setError('Cancel reason must be at most 30 characters.');
            return;
        }

        setError('');
        setLoading(true);



        try {
            const url = `students/admission-cancellation/?student_id=${cancelStudentId}&cancellation_reason=${encodeURIComponent(reason.trim())}`;
            const response = await getData(url);
            setCancelData(response)

            if (response && !response.error) {
                displayToast("OTP sent successfully");
                setStep(2); // go to OTP step
            } else {
                displayToast(response?.error || "Failed to send OTP", "danger");
            }
        } catch (error) {
          
            const errorMsg =
                error?.response?.data?.message ||
                error?.message ||
                'Failed to send OTP. Please try again.';
            displayToast(errorMsg, 'danger');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (step === 2 && otpRefs.current[0]) {
            otpRefs.current[0].focus();
        }
    }, [step]);

    const handleOtpChange = (value, index) => {
        if (!/^[0-9]?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 5) {
            otpRefs.current[index + 1].focus();
        }

        if (!value && index > 0) {
            otpRefs.current[index - 1].focus();
        }
    };



    const handleOtpSubmit = async () => {
        const otpValue = otp.join('');
        if (otpValue.length !== 6) {
            setError('Please enter all 6 digits of OTP.');
            return;
        }

        const payload = {
            otp: otpValue,
            mobile: cancelData.teachers,
            cancellation_reason: cancelData.cancellation_reason,
        };

        try {
            setLoading(true);
            const url = `students/admission-cancellation/?student_id=${cancelStudentId}`;
            const response = await Postdata(url, payload);
 

            if (response && !response.error) {
                displayToast('Admission cancelled successfully', 'success');
                setTimeout(() => {
                    fetchStudents();
                    onClose();
                    setLoading(false);
                }, 1000);

                return;
            }

            if (response?.error) {
                displayToast(response?.error, 'danger');
            }

        } catch (error) {
            console.error("Cancellation failed:", error);
            const errorMsg =
                error?.response?.data?.message ||
                error?.message ||
                'Cancellation failed. Please try again.';
            displayToast(errorMsg, 'danger');
        }
        // no need for `finally`, since `loading` is cleared in success handler
    };







    if (!isOpen) return null;

    return (
        <>
            <div className="modal-overlay">
                <div className="modal-content" style={{ position: 'relative', width: '40%' }}>
                    <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <h2 className="text-primary"> Cancel Admission</h2>
                        <button className="close-btn" onClick={onClose}><img src={close} alt="close" /></button>
                    </div>
                    <div className="modal-body cacelAdmissionModal">
                        {step === 1 && (
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label className="form-labell">Reason for Cancellation <span className="astrisk">*</span></label>
                                        <textarea
                                            ref={nameInputRef}
                                            rows="4"
                                            className="fm-modal form-control"
                                            placeholder="Enter cancellation reason (at most 30 character)"
                                            value={reason}
                                            onChange={(e) => setReason(e.target.value)}
                                        />
                                        {error && <small className="text-danger">{error}</small>}
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-12 d-flex justify-content-end">
                                        <button
                                            className="add-btn"
                                            onClick={handleReasonConfirm}
                                            style={{ minWidth: '150px', maxWidth: '180px', width: '100%', display: 'flex', justifyContent: 'center' }}
                                        >
                                            {loading ? (
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            ) : (
                                                'Confirm'
                                            )}
                                            {!loading && <img src={next} className="ms-2" alt="next" />}
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}

                        {step === 2 && (
                            <>
                                <div className="text-center mb-3">
                                    <p>Enter 6-digit OTP sent to authorized person.</p>


                                </div>
                                <div className="d-flex justify-content-center gap-2">
                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            type="text"
                                            className="otp-input"
                                            maxLength="1"
                                            value={digit}
                                            onChange={(e) => handleOtpChange(e.target.value, index)}
                                            ref={(el) => (otpRefs.current[index] = el)}
                                            style={{
                                                width: '40px',
                                                height: '45px',
                                                textAlign: 'center',
                                                fontSize: '20px',
                                                borderRadius: '5px',
                                                border: '1px solid #ccc',
                                            }}
                                        />
                                    ))}
                                </div>
                                {error && <div className="text-danger text-center mt-2">{error}</div>}
                                <div className="row mt-4">
                                    <div className="col-md-12 d-flex justify-content-between">
                                        <div className="text-center">
                                            {resendEnabled ? (
                                                <button
                                                    className="btn btn-link p-0 text-primary"
                                                    style={{ fontSize: '14px', textDecoration: 'underline' }}
                                                    onClick={handleResendOtp}
                                                >
                                                    Resend OTP
                                                </button>
                                            ) : (
                                                <small className="text-muted">Resend available in {secondsLeft} sec</small>
                                            )}
                                        </div>
                                        <button
                                            className="add-btn"
                                            onClick={handleOtpSubmit}
                                            disabled={loading}
                                            style={{
                                                minWidth: '150px',
                                                maxWidth: '180px',
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            {loading ? (
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            ) : (
                                                'Submit'
                                            )}
                                            {!loading && <img src={next} className="ms-2" alt="next" />}
                                        </button>

                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {showToast && (
                <div
                    className={`custom-toast toast align-items-center text-white bg-${toastVariant} border-0 position-fixed top-0 end-0 m-3`}
                    role="alert"
                    style={{
                        display: 'block',
                        minWidth: '300px',
                        maxWidth: '400px',
                        borderRadius: '8px',
                        boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                        fontSize: '15px',
                        zIndex: 9999
                    }}>
                    <div className="d-flex">
                        <div className="toast-body" style={{ padding: '12px 16px' }}>
                            <strong>{toastVariant === 'success' ? '✅' : '❌'} </strong> {toastMessage}
                        </div>
                        <button
                            type="button"
                            className="btn-close btn-close-white me-2 m-auto"
                            onClick={() => setShowToast(false)}
                            aria-label="Close"
                        ></button>
                    </div>
                </div>

            )}
        </>
    );
};
